import React from "react";

export const CharacterizationLoader = ({ size = "md", className = "" }) => {
  const sizeClasses = {
    sm: "w-6 h-6 border-2",
    md: "w-12 h-12 border-[3px]",
    lg: "w-16 h-16 border-4",
  };

  const spinner = (
    <div
      className={`${className} flex flex-col items-center justify-center gap-3`}
    >
      <div className="relative">
        <div
          className={`${sizeClasses[size]} border-[#2AB9B8] border-t-transparent rounded-full animate-spin`}
          role="status"
          aria-label="Chargement en cours"
        >
          <span className="sr-only">Chargement...</span>
        </div>
        {/* Subtle pulsing ring effect */}
        <div
          className={`absolute inset-0 ${sizeClasses[size]} border-[#2AB9B8] border-opacity-20 rounded-full animate-ping`}
        />
      </div>
    </div>
  );

  return spinner;
};

/**
 * Inline loader for containers/cards
 */
export const InlineLoader = ({ height = "200px", className = "" }) => {
  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{ minHeight: height }}
    >
      <CharacterizationLoader size="md" />
    </div>
  );
};

/**
 * Fullscreen overlay loader (replaces LoadingScreen)
 */
export const LoadingOverlay = ({ className = "", message = "" }) => {
  return (
    <div
      className={`fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex flex-col items-center justify-center ${className}`}
    >
      <CharacterizationLoader size="lg" />
      {message && (
        <p className="mt-4 text-sm text-[#0F265C] text-center max-w-md px-4">
          {message}
        </p>
      )}
    </div>
  );
};
